// @ts-nocheck
import { useEffect } from "react";
import cloneDeep from "lodash.clonedeep";
import { generatePositions, validateMultiplePositions } from "../../utils/gameUtils/putItemOnGrid";
import { DIMENSION_GRID } from "../../contants";
import { eventEmitter } from "../../EventEmitter";
import { DragItemType, GridItemType, GridType } from "../../types";
import {validatePosition} from "../../utils/gameUtils/validatePositions";

interface Props {
    gridData: GridItemType[][];
    dragItems: DragItemType[];
    setGridData: (data: GridType) => void;
}

// Проверка на заполнение строки или столбца
function checkIfCompletesLineOrColumn(copyGridData: GridType, positions: number[][]): boolean {
    const rows = new Set<number>();
    const cols = new Set<number>();

    for (const [row, col] of positions) {
        rows.add(row);
        cols.add(col);
    }

    // Проверка строк
    for (const row of rows) {
        if (copyGridData[row].every(cell => cell.item || positions.some(([_row, col]) => _row === row && col === cell.col))) {
            return true;
        }
    }

    // Проверка столбцов
    for (const col of cols) {
        if (copyGridData.every(row => row[col].item || positions.some(([rowIndex, _col]) => rowIndex === row[col].row && _col === col))) {
            return true;
        }
    }

    return false;
}

/**
 * @experemental function
 * Проверяет доступные к использованию элементы на их вставку на поле
 * Предпочтение отдает местам, при которых заполнится столбец или строка
 * Иначе вставляется в первое попавшееся место
 * **/
export const useShowPossiblePositionHint = ({ dragItems, gridData, setGridData }: Props) => {
    useEffect(() => {
        const handleShowPossiblePositionHint = () => {
            const copyGridData = cloneDeep(gridData);

            // Массив для хранения всех валидных позиций, которые могут заполнить строку или столбец
            let prioritizedPositions: { coords: number[][], item: DragItemType }[] = [];
            let fallbackPositions: { coords: number[][], item: DragItemType }[] = [];

            // Сначала ищем позиции, которые заполнят строку или столбец
            for (const item of dragItems) {
                const pos = generatePositions(DIMENSION_GRID);
                const results = validateMultiplePositions(pos, gridData, item);

                for (const result of results) {
                    if (checkIfCompletesLineOrColumn(copyGridData, result)) {
                        prioritizedPositions.push({ coords: result, item });
                    } else {
                        fallbackPositions.push({ coords: result, item });
                    }
                }
            }

            let selectedPositions = prioritizedPositions.length ? prioritizedPositions[0] : (fallbackPositions.length ? fallbackPositions[0] : null);
            if (selectedPositions) {
                for (let i = 0; i < selectedPositions.coords.length; i++) {
                    const iRow = selectedPositions.coords[i][0];
                    const iCol = selectedPositions.coords[i][1];

                    const positions = validatePosition(iRow, iCol, copyGridData, selectedPositions.item);
                    if (positions.length) {
                        // TODO протестить это место тщательнее
                        for (let [posRow, posCol] of selectedPositions.coords) {
                            copyGridData[posRow][posCol].isHinted = true;
                        }
                        break;
                    }
                }
            }

            setGridData(copyGridData);
        }

        eventEmitter.on('showHint', handleShowPossiblePositionHint);

        return () => {
            eventEmitter.off('showHint', handleShowPossiblePositionHint);
        };
    }, [gridData, dragItems])
}


//Stupid hint
// import {useEffect} from "react";
// import cloneDeep from "lodash.clonedeep";
// import {generatePositions, validateMultiplePositions} from "../../utils/gameUtils/putItemOnGrid";
// import {DIMENSION_GRID} from "../../contants";
// import {validatePosition} from "../../utils/gameUtils/validatePositions";
// import {eventEmitter} from "../../EventEmitter";
// import {DragItemType, GridItemType, GridType} from "../../types";
//
// interface Props {
//     gridData: GridItemType[][];
//     dragItems: DragItemType[];
//     setGridData: (data: GridType) => void;
// }
//
// export const useShowPossiblePositionHint = ({dragItems, gridData, setGridData}: Props) => {
//     useEffect(() => {
//         const handleShowPossiblePositionHint = () => {
//             const copyGridData = cloneDeep(gridData);
//
//             const {coords, _item} = dragItems.reduce((acc, item) => {
//                 const pos = generatePositions(DIMENSION_GRID);
//                 const results = validateMultiplePositions(pos, gridData, item);
//
//                 if (results.length) {
//                     acc.coords = results.flat() as any;
//                     acc._item = item as any;
//                 }
//
//                 return acc;
//             }, {coords: [], _item: undefined})
//
//             for (let i = 0; i < coords.length; i++) {
//                 const iCol = coords[i][0];
//                 const iRow = coords[i][1];
//
//                 const positions = validatePosition(iCol, iRow, copyGridData, _item as any);
//
//                 if (positions.length) {
//                     for (let [posCol, posRow] of positions) {
//                         copyGridData[posCol][posRow].isHinted = true;
//                     }
//                     break;
//                 }
//             }
//
//             setGridData(copyGridData);
//         }
//
//
//         eventEmitter.on('showHint', handleShowPossiblePositionHint);
//
//         return () => {
//             eventEmitter.off('showHint', handleShowPossiblePositionHint);
//         };
//     }, [gridData, dragItems])
// }


//more smarter
// import { useEffect } from "react";
// import cloneDeep from "lodash.clonedeep";
// import { generatePositions, validateMultiplePositions } from "../../utils/gameUtils/putItemOnGrid";
// import { DIMENSION_GRID } from "../../contants";
// import { validatePosition } from "../../utils/gameUtils/validatePositions";
// import { eventEmitter } from "../../EventEmitter";
// import { DragItemType, GridItemType, GridType } from "../../types";
//
// interface Props {
//     gridData: GridItemType[][];
//     dragItems: DragItemType[];
//     setGridData: (data: GridType) => void;
// }
//
// // Проверка на заполнение строки или столбца
// function checkIfCompletesLineOrColumn(copyGridData: GridType, positions: number[][]): boolean {
//     const rows = new Set<number>();
//     const cols = new Set<number>();
//
//     for (const [row, col] of positions) {
//         rows.add(row);
//         cols.add(col);
//     }
//
//     // Проверка строк
//     for (const row of rows) {
//         if (copyGridData[row].every(cell => cell.item || positions.some(([_row, col]) => _row === row && col === cell.col))) {
//             return true;
//         }
//     }
//
//     // Проверка столбцов
//     for (const col of cols) {
//         if (copyGridData.every(row => row[col].item || positions.some(([rowIndex, _col]) => rowIndex === row[col].row && _col === col))) {
//             return true;
//         }
//     }
//
//     return false;
// }
//
// export const useShowPossiblePositionHint = ({ dragItems, gridData, setGridData }: Props) => {
//     useEffect(() => {
//         const handleShowPossiblePositionHint = () => {
//             const copyGridData = cloneDeep(gridData);
//
//             // Массив для хранения всех валидных позиций, которые могут заполнить строку или столбец
//             let prioritizedPositions: { coords: number[][], item: DragItemType }[] = [];
//             let fallbackPositions: { coords: number[][], item: DragItemType }[] = [];
//
//             // Сначала ищем позиции, которые заполнят строку или столбец
//             for (const item of dragItems) {
//                 const pos = generatePositions(DIMENSION_GRID);
//                 const results = validateMultiplePositions(pos, gridData, item);
//
//                 for (const result of results) {
//                     if (checkIfCompletesLineOrColumn(copyGridData, result)) {
//                         prioritizedPositions.push({ coords: result, item });
//                     } else {
//                         fallbackPositions.push({ coords: result, item });
//                     }
//                 }
//             }
//
//             let selectedPositions = prioritizedPositions.length ? prioritizedPositions[0] : (fallbackPositions.length ? fallbackPositions[0] : null);
//
//             if (selectedPositions) {
//                 for (let i = 0; i < selectedPositions.coords.length; i++) {
//                     const iRow = selectedPositions.coords[i][0];
//                     const iCol = selectedPositions.coords[i][1];
//
//                     const positions = validatePosition(iRow, iCol, copyGridData, selectedPositions.item);
//
//                     if (positions.length) {
//                         for (let [posRow, posCol] of positions) {
//                             copyGridData[posRow][posCol].isHinted = true;
//                         }
//                         break;
//                     }
//                 }
//             }
//
//             setGridData(copyGridData);
//         }
//
//         eventEmitter.on('showHint', handleShowPossiblePositionHint);
//
//         return () => {
//             eventEmitter.off('showHint', handleShowPossiblePositionHint);
//         };
//     }, [gridData, dragItems])
// }
